const mapColorType = {
  secondary: "secondary",
  primary: "primary",
  invert: "inherit"
}, mapSizesIconContainer = {
  sm: "30px",
  md: "42px"
};
export {
  mapColorType,
  mapSizesIconContainer
};
//# sourceMappingURL=constants.js.map
